import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets/constants';

export async function getAllKitInsights(tinyAccountId: string) {
  return await API.get(
    apiName,
    `${apiBasePath}/results/allKitsInsight/${tinyAccountId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.PROFILE,
        domain: DOMAINS.RESULTS,
        importance: IMPORTANCE.MEDIUM,
      },
      context: {
        tinyAccountId,
      },
    },
  );
}

const useAllKitsInsight = (tinyAccountId?: string | null) => {
  const actionPlanItemQuery = useSuspenseQuery({
    queryKey: [apiName, 'allKitsInsight', tinyAccountId],
    queryFn: () => tinyAccountId && getAllKitInsights(tinyAccountId),
  });
  return actionPlanItemQuery;
};

export default useAllKitsInsight;
